import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loader = ({ size }) => {
  return <CircularProgress size={size || 16} color="primary" />;
};

export default Loader;
